import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

import { TableFiltersWithDate } from 'components';
import {
  exceptionLogsTextSearchState,
  exceptionLogsEndDateState,
  exceptionLogsFiltersState,
  exceptionLogsStartDateState,
} from 'store';
import { FilterOption } from 'types';

type ExceptionLogsMonitorFiltersProps = {
  filters: FilterOption[];
  collapsible?: boolean;
};

export const ExceptionLogsMonitorFilters: React.FC<ExceptionLogsMonitorFiltersProps> = ({
  filters,
  collapsible = true,
}) => {
  const [monitorFilters, setMonitorFilters] = useRecoilState(exceptionLogsFiltersState);
  const [monitorStartDate, setMonitorStartDate] = useRecoilState(exceptionLogsStartDateState);
  const [monitorEndDate, setMonitorEndDate] = useRecoilState(exceptionLogsEndDateState);
  const { t } = useTranslation('monitor');

  useEffect(() => {
    setMonitorFilters(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TableFiltersWithDate
      filters={monitorFilters}
      onSetSelectedFilters={setMonitorFilters}
      collapsible={collapsible}
      showDateFilter={true}
      initialEndDate={monitorEndDate}
      initialStartDate={monitorStartDate}
      onSetEndDate={setMonitorEndDate}
      onSetStartDate={setMonitorStartDate}
      fromDateLabel={t('date_range_from_title', 'Start date')}
      toDateLabel={t('date_range_to_title', 'End date')}
      textSearchState={exceptionLogsTextSearchState}
    />
  );
};
